// extracted by mini-css-extract-plugin
module.exports = {"container":"SimilarVehiclesEmptyState_container__JoC9Q","text":"SimilarVehiclesEmptyState_text__Yx_Qx","image":"SimilarVehiclesEmptyState_image__TtrPT"};